
import "./App.css";

export default function NavBar() {
  return (
    <>
      <div>
        <header>
          <a href="" className="container-fluid logo-auto-gas-yoni">
            AutoGas Yony
          </a>
          <nav className="navbar navbar-expand-md ">
            <div className="container-fluid">
              <a className="navbar-brand" href="#"></a>
              <button
                className="navbar-toggler"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#navbarNav"
                aria-controls="navbarNav"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span className="navbar-toggler-icon"></span>
              </button>
              <div className="collapse navbar-collapse" id="navbarNav">
                <ul className="navbar-nav">
                  <li className="nav-item">
                    <a
                      id="a-reverlde"
                      className="nav-link active fw-bold"
                      href="#carouselExampleInterval"
                    >
                      Inicio
                    </a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link fw-bold" href="#servicio">
                      Productos
                    </a>
                  </li>

                  <li className="nav-item">
                    <a className="nav-link fw-bold" href="#equipo">
                      Equipo
                    </a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link fw-bold" href="#contacto">
                      Contactos
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </nav>
        </header>


{/*  Esta es la funcion para desaparecer la barra superior  */}

        <section className="onezone"></section>
        {window.addEventListener("scroll", function () {
          var header = document.querySelector("header");
          header.classList.toggle("abajo", window.scrollY > 0);
        })}
      </div>
    </>
  );
}
